import { UserModelRole } from "target_wasm";

enum ResourceType {
  Model = "Model",
  Table = "Table",
  Dataset = "Dataset",
}
enum Permission {
  CanImport = "SharedWith",
  CanShare = "SharedWithReshare",
}

interface RemoveAccessData {
  email?: string;
  clientId?: string;
  oldRole: string;
  isPending?: boolean;
}

export interface ShareOutcome {
  atCapacityEmails?: string[];
  /// Addresses a partial-success door (datasets) refused while serving the
  /// rest. The table door never populates this — it refuses whole batches.
  refusedEmails?: string[];
}

interface InputShareFieldProps {
  entityId: string;
  /// May resolve with the addresses a full account cap left uninvited: a warning
  /// on a success, not a failure.
  shareAction: (
    emails: string[],
    accessLevel: UserModelRole | Permission | null,
  ) => void | Promise<ShareOutcome | void>;
  resourceType: ResourceType;
  defaultRole: UserModelRole | null;
  defaultPermission: Permission | null;
  /// Shows the composer but blocks Share (e.g. awaiting a published release);
  /// `canShare` hides it entirely for viewers.
  shareDisabled?: boolean;
  /// A non-personal org's model: suggest its roster and keep entry to it (D19).
  rosterOrg?: { id: string; name: string };
}

export const validateEmail = (email: string) => {
  return /^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(email);
};

/// A model's Direct access tab other than All, as the server's `role` names it.
export type DirectRole = "collaborator" | "viewer" | "invited";

export interface RefetchOptions {
  search?: string;
  continuationToken?: string | null;
  limit?: number;
  role?: DirectRole;
}

export type { InputShareFieldProps, RemoveAccessData };
export { Permission, ResourceType };
